//swiper
import Swiper from 'swiper/bundle';
export default class Goods {
    constructor() {
        this.clicked = false;
        this.init();
    }

    init() {
        this.fetchContent();
        this.tab();
    }

    fetchContent() {
        const trigger = [...document.querySelectorAll('.js-fetch_open')];
        const close = [...document.querySelectorAll('.js-fetch_close')];
        const inner = document.querySelector('.js-fetch_content');

        trigger.forEach((el) => {
            el.addEventListener('click', () => {
                //連打防止
                if (this.clicked === true) {
                    return;
                }

                this.clicked = true;

                const url = el.getAttribute('data-url');

                fetch(url)
                    .then((res) => res.text())
                    .then((data) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(data, 'text/html');
                        const content = doc.querySelector('.artgoodsmodal__row');
                        inner.appendChild(content);
                        this.setSwiper();
                    });
            });
        });

        close.forEach((el) => {
            el.addEventListener('click', () => {
                this.removeContent();
            });
        });
    }

    setSwiper() {
        const thumb = document.querySelectorAll('.artgoodsmodal__thumb__item');

        const firstactiveitem = document.querySelector('[data-swiper="0"]');
        firstactiveitem.classList.add('-active');

        const swiper = new Swiper('.artgoodsmodal__swiper', {
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                beforeTransitionStart: (e) => {
                    const thumbs = document.querySelector('.artgoodsmodal__thumb__item.-active');
                    thumbs.classList.remove('-active');

                    const activenum = e.activeIndex;

                    const activeitem = document.querySelector('[data-swiper="' + activenum + '" ]');
                    activeitem.classList.add('-active');
                },
            },
        });

        thumb.forEach((el) => {
            el.addEventListener('click', () => {
                const thumbnum = el.dataset.swiper;
                swiper.slideTo(thumbnum);
            });
        });
    }

    removeContent() {
        const content = [...document.querySelectorAll('.artgoodsmodal__row')];
        content.forEach((el) => el.remove());
        this.clicked = false;
    }

    tab() {
        const tab = [...document.querySelectorAll('.js-artgoods_tab')];
        const panel = [...document.querySelectorAll('.js-artgoods_panel')];

        tab.forEach((el) => {
            el.addEventListener('click', () => {
                // 全タブのactiveを外す
                tab.forEach((_el) => {
                    _el.classList.remove('-active');
                });

                // 押されたタブにactiveを付与
                el.classList.add('-active');

                // 押されたタブと同じカテゴリのパネルにactiveを付与
                const currentCat = el.dataset.cat;
                panel.forEach((_el) => {
                    _el.classList.remove('-active');
                    if (_el.dataset.cat === currentCat) {
                        _el.classList.add('-active');
                    }
                });
            });
        });
    }

    changeCat(val) {
        console.log(val.dataset.cat);
    }
}
